export default __webpack_public_path__ + "static/media/Carosel P 2.f6e318c8.svg";